import { format } from 'sql-formatter'

// mustache 記法は paramTypes で 1 トークン扱いにして整形対象から外す。
// 最短一致にしないと {{# queries }} ... {{/ queries }} のように {{ }} が複数ある SQL が丸ごと 1 つに飲み込まれ、
// 内側の波括弧を省略可にしないと {{{ query }}} が末尾の } を余らせて構文エラーになる。
const MUSTACHE_TAG = String.raw`\{\{\{?.+?\}?\}\}`

// sql-formatter は解釈できない入力に例外を投げる。検索条件 SQL は保存時にも実行時にも構文検証されないため、
// 整形できない値をそのまま返さないと、その値を initialValues に使うフォーム自体が描画できなくなる。
export const formatSqlWithMustache = (sql: string): string => {
  try {
    return format(sql, { language: 'postgresql', paramTypes: { custom: [{ regex: MUSTACHE_TAG }] } })
  } catch {
    return sql
  }
}
